import BaseService from "services/BaseService"

class PublicContentService extends BaseService {
  async getLandingPages({ page = 1, page_size = 20, keyword = "" } = {}) {
    return this._api.post("store/seo/getlandingpages", {
      page,
      page_size,
      keyword,
    })
  }

  async getLandingBySlug(slug) {
    const slugText = String(slug || "").trim().toLowerCase()
    if (!slugText) {
      return null
    }

    return this._api.post("store/seo/getlandingpage", { slug: slugText })
  }

  async getPostBySlug(slug) {
    const slugText = String(slug || "").trim().toLowerCase()
    if (!slugText) {
      return null
    }

    return this.getLandingBySlug(slugText)
  }
}

export default PublicContentService
